/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

export interface SourceSystem {
  code?: string | null;
  name?: string | null;
}

export class SourceSystem {
  code?: string | null;
  name?: string | null;

  constructor(value: SourceSystem) {
    this.code = value?.code;
    this.name = value?.name;
  }
}
